/**
 * @GENERATED from Figma node 3608:51028
 */

import { useUniqueInlineId } from "@inline-svg-unique-id/react";
import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const MsSharepointDark = function (
  props: IconProps,
  ref: React.Ref<SVGSVGElement>,
) {
  const _id = useUniqueInlineId();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      focusable={false}
      role="presentation"
      ref={ref}
      {...props}
    >
      <path
        fill="#036C70"
        d="M10.767 14.238c3.545 0 6.419-2.814 6.419-6.286s-2.874-6.285-6.419-6.285S4.35 4.48 4.35 7.952s2.873 6.286 6.418 6.286"
      />
      <path
        fill="#1A9BA1"
        d="M16.116 17.476c3.25 0 5.884-2.58 5.884-5.762s-2.634-5.761-5.884-5.761-5.884 2.58-5.884 5.761c0 3.183 2.635 5.762 5.884 5.762"
      />
      <path
        fill="#37C6D0"
        d="M11.57 22.667c2.51 0 4.546-1.994 4.546-4.453s-2.035-4.452-4.546-4.452-4.547 1.993-4.547 4.452c0 2.46 2.036 4.453 4.547 4.453"
      />
      <path
        fill="#000"
        fillOpacity={0.3}
        fillRule="evenodd"
        d="M7 12.042V9.35a2.5 2.5 0 0 1 2.5-2.5H12a2.5 2.5 0 0 1 2.5 2.5v6.25a2.5 2.5 0 0 1-2.5 2.5H7.025c.051-1.999 1.448-3.67 3.337-4.18a6 6 0 0 1-.107-.702A6.47 6.47 0 0 1 7 12.042"
        clipRule="evenodd"
      />
      <path
        fill={`url(#${_id})`}
        d="M2 7.475c0-.92.746-1.667 1.667-1.667H12c.92 0 1.667.747 1.667 1.667v8.334c0 .92-.746 1.666-1.667 1.666H3.667c-.92 0-1.667-.746-1.667-1.667z"
      />
      <path
        fill="#fff"
        d="M6.244 11.524a1.8 1.8 0 0 1-.561-.581 1.56 1.56 0 0 1-.195-.795 1.5 1.5 0 0 1 .363-1.03 2.15 2.15 0 0 1 .966-.616 4.2 4.2 0 0 1 1.32-.2c.589-.021 1.177.06 1.738.238v1.205a2.8 2.8 0 0 0-.787-.314c-.3-.073-.61-.109-.919-.108a2 2 0 0 0-.945.196.61.61 0 0 0-.375.556c0 .147.057.288.16.394.123.125.269.226.429.3a14 14 0 0 0 .917.391c.35.134.69.298 1.012.489.244.147.449.35.598.59.152.272.226.58.213.89.018.385-.102.764-.34 1.072a1.9 1.9 0 0 1-.909.6c-.42.128-.857.19-1.297.184a7 7 0 0 1-1.176-.095 4 4 0 0 1-.954-.274v-1.27a3.1 3.1 0 0 0 .963.45c.344.105.702.161 1.062.167.334.02.667-.049.963-.2a.63.63 0 0 0 .328-.566.6.6 0 0 0-.182-.432 1.8 1.8 0 0 0-.5-.342 17 17 0 0 0-.946-.415 5.4 5.4 0 0 1-.946-.484"
      />
      <defs>
        <linearGradient
          id={_id}
          x1={2.731}
          x2={13.046}
          y1={6.816}
          y2={16.933}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#058F92" />
          <stop offset={1} stopColor="#026F73" />
        </linearGradient>
      </defs>
    </svg>
  );
};
const ForwardRef = React.forwardRef(MsSharepointDark);
export { ForwardRef as MsSharepointDark };
